<template>
  <div class="editor-jd-pop" @click.stop>
    <section v-if="step == 0" class="editor-pop-content1 pop-alert">
      <div class="editor-pop-topline">
        修改京东PID
      </div>
      <div class="g-close" @click="hideSaasPop">
        <img src="../../assets/icon-close@2x.png" width="12" alt>
      </div>
      <div class="editor_JD_avator">
        <img class="icon-tip" src="../../assets/icon-warning-red.png" alt>
      </div>


      <div style="color:#BFBFBF">
        已绑定PID: {{ jdId }}
      </div>

      <p>修改京东账户操作将影响后续账号佣金结算！</p>
      <p>(如因误触操作请点击“取消操作”按钮）</p>
      <footer class="footer">
        <el-button @click="startEditor" type="primary" size="small">确认修改</el-button>
        <el-button @click="hideSaasPop" size="small">取消操作</el-button>
      </footer>
    </section>

    <section v-if="step ==1" class="editor-pop-content1 pop-alert">
      <div class="editor-pop-topline">
        解绑PID
      </div>
      <div class="g-close" @click="hideSaasPop">
        <img src="../../assets/icon-close@2x.png" width="12" alt>
      </div>
      <EditJdStep :state="0" />
      <div style="color:#111111;font-size:14px;margin-top:30px;margin-bottom:20px">
        验证码发送至: {{ jdTel }}
      </div>

      <div>
        <qc-input id="code" v-model="form.code" placeholder="请输入验证码" />
        <sms-code-button :phone="form.phone" countdownTextHeight="40">
          <template #button>
            <qc-button id="code-btn">获取验证码</qc-button>
          </template>
        </sms-code-button>

        <div v-if="!errormess" style="width:100%;text-align:left;margin-top:10px;color:black">
          *账号验证通过后会解绑京东pid
        </div>
        <div v-if="errormess" style="width:100%;text-align:left;margin-top:10px;color:red">
          {{ errormess }}
        </div>
      </div>

      <footer class="footer">
        <el-button
          v-if="unbindstep === 0"
          style="width:332px"
          type="primary"
          :loading="binding"
          @click="ValidTelPhone"
        >
          确认解绑，进入下一步
        </el-button>
      </footer>
    </section>

    <section v-show="step === 2" class="editor-pop-content1">
      <div class="editor-pop-topline">
        修改PID
      </div>
      <div class="g-close" @click="hideSaasPop">
        <img src="../../assets/icon-close@2x.png" width="12" alt>
      </div>
      <EditJdStep :state="endStep" />


      <div class="guide-item1">
        <div>
          <div style="width:300px;text-align:left;margin:0 auto;font-size:12px;margin-bottom:10px">
            输入京东PID：
          </div>
          <qc-input v-model="jdPid" placeholder="请输入新的京东PID账号" />
          <div style="width:100%;text-align:left;margin-top:10px;color:red">
            {{ errormess }}
          </div>
          <div class="tip">
            <div>
              <p>* 绑定后将以新的PID账号进行佣金结算</p>
              <p>* 注意一个PID仅可使用一次；一个京东账号可申请多个PID。</p>
              <qc-bubble placement="bottomLeft" style="position:absolute;right:5px;transform-origin:0 0;transform:scale(0.8);top:236px">
                <span class="em" style="color:blue">如何申请</span>
                <template slot="popup">
                  <p>1. 点击去“获取京东PID”</p>
                  <p>2. 点击“新增备案”</p>
                  <img class="multi-pid-img" src="../../assets/multi-pid.png" width="270" alt>
                </template>
              </qc-bubble>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer">
        <qc-button type="weak" @click.stop="goToJdBindPage">
          获取京东PID
        </qc-button>
        <qc-button
          class="bindSaasPopBtn"
          data-compname="bindSaasPopBtn"
          data-saas_type="jd"
          :disabled="binding"
          @click="confirmBindJd"
        >
          下一步
        </qc-button>
      </footer>
    </section>

    <section v-if="step == 3" class="editor-pop-content1 pop-alert">
      <div class="editor-pop-topline">
        修改完成
      </div>
      <div class="g-close" @click="hideSaasPop">
        <img src="../../assets/icon-close@2x.png" width="12" alt>
      </div>
      <div class="editor_JD_avator">
        <img class="icon-tip" src="../../assets/icon-success1.png" alt>
      </div>


      <div style="color:#BFBFBF">
        已绑定PID: {{ jdId }}
      </div>

      <p>
        已成功绑定新的京东PID账号
      </p>
      <p>账号佣金结算将以此新账号进行结算发放</p>
      <footer class="footer">
        <qc-button @click="hideSaasPop">
          完成
        </qc-button>
      </footer>
    </section>
  </div>
</template>

<script>
/**
 * 京东PID 换绑
 */
import commonMixin from '@/mixins/common';
import { mapState, mapGetters } from 'vuex';
import EditJdStep from './steps/editorJdIDStep';
import SmsCodeButton from '@/components/sms-code-button';
import userCenterApi from '@/apis/userCenter/index';
import commonApi from '@/apis/common';

const initData = {
  isClickJdBind: false,
  showBubble: false,
  jdPid: '',
  step: 0,
  isPhoneValid: false,
  changePhone: false,
  changeText: '修改',
  errormess: '',
  binding: false,
  unbindstep: 0,
  showUnBindBtn: false,
  form: {
    phone: '',
    code: '',
  },
  endStep: 1,
};

export default {
  name: 'EditorJdPop',
  components: {
    EditJdStep,
    SmsCodeButton,
  },
  mixins: [commonMixin],
  data() {
    return {
      ...initData,
    };
  },
  computed: {
    ...mapState({
      profile: state => state.userCenter.profile,
      bindSaasPop: state => state.common.bindSaasPop,
    }),
    ...mapGetters({
      isBindJd: 'userCenter/isBindJd',
      saasInfo: 'userCenter/saasInfo',
      isBindMk: 'userCenter/isBindMk',
    }),

    jdTel() {
      const { phone } = this.profile;

      return Object.values(phone).map((item, index) => {
        if (index > 3 && index <= 7) {
          return '*';
        }

        return item;
      })
        .join('');
    },
    jdId() {
      return this.bindSaasPop.bindStateTemplate.saas_id;
    },
    jdBindUrl() {
      return this.getBindUrl('jd');
    },
  },
  created() {
    this.form.phone = this.profile.phone;
  },
  methods: {
    getBindUrl(saasType) {
      const bindInfo = this.profile.saas_binding.filter(item => item && item.mask === saasType)[0];
      return bindInfo ? bindInfo.authenticate_entry : '';
    },

    goToJdBindPage() {
      if (!this.jdBindUrl) {
        this.$tip.error('京东绑定URL不存在');
        return;
      }

      if (this.step === 1) {
        this.step += 1;
      }

      window.open(this.jdBindUrl);
      this.isClickJdBind = true;
    },
    onClose() {
      this.$store.commit('common/HIDE_BIND_SAAS_POP');
    },

    reqUnbindSaas() {
      this.binding = true;
      const reqData = {
        saas_type: 'jd',
        saas_id: this.bindSaasPop.bindStateTemplate.saas_id,
      };
      userCenterApi.unbindSaas(reqData, false)
        .then((res) => {
          const code = Number(res?.head?.code);
          if (code !== 0) {
            const errorMsg = `[${code}] 解绑失败：${res?.head?.msg}`;
            this.$message.error(errorMsg);
            return;
          };

          // 重新拉取 profile
          this.$store.dispatch('userCenter/fetchCpProfile', { showLoading: false });
          this.step = 2;
        })
        .catch((err) => {
          const errorMsg = `[${err?.code}] 解绑失败：${err?.message}`;
          this.$message.error(errorMsg);
        })
        .finally(() => {
          this.binding = false;
        });
    },

    reqVerifySmscode() {
      if (this.binding) return;
      this.binding = true;

      const reqData = {
        phone_number: this.form.phone,
        code: this.form.code,
      };
      commonApi.verifySmsCode(reqData, this)
        .then((res) => {
          this.binding = false;
          if (Number(res?.head?.code) === 0) {
            // 验证成功之后开始解绑
            this.reqUnbindSaas();
          };
        })
        .catch(() => {
          this.binding = false;
        });
    },

    async ValidTelPhone() {
      if (!this.form.code) {
        this.errormess = '请输入验证码';
        return;
      }

      this.errormess = '';
      this.form.phone = this.profile.phone;

      this.reqVerifySmscode();
    },
    startEditor() {
      this.step = 1;
    },
    /**
     * 更换PID逻辑
     * 验证当前输入PID是否有效 -> 解绑当前用户已绑定的PID ->  绑定当前输入的PID
     */
    async confirmBindJd() {
      this.errormess = '';
      if (!this.jdPid) {
        this.errormess = 'PID不能为空';
        return;
      }

      // 开始绑定
      const reqPromise = this.bindJdPid(this.jdPid);
      reqPromise.then(async (res) => {
        if (res.code === 0) {
          await this.$store.dispatch('userCenter/fetchCpProfile');
          if (!this.isBindJd) {
            return;
          }

          this.binding = false;
          this.step += 1;
          // 绘制新的saasid
          this.bindSaasPop.bindStateTemplate.saas_id = this.jdPid;
        }
      });
    },
    hideSaasPop() {
      this.step = 0;
      this.form.code = '';
      this.binding = false;
      this.unbindstep = 0;
      this.jdPid = '';
      this.isPhoneValid = false;
      this.$store.commit('common/HIDE_BIND_SAAS_POP');
    },
  },
};
</script>

<style lang="less" scoped>
@popH: 500px;
@popHeaderH: 100px;
@popFooterH: 80px;
@radius: 4px;
@inputH: 40px;

.editor-jd-pop {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 3;
  background-color: rgba(33, 33, 33, 0.6);
  .g-close {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 20px;
    height: 20px;
    margin-top: 0px !important;
    img {
      cursor: pointer;
      margin-top: 0px !important;
    }
  }
  .editor-pop-topline {
    width: 100%;
    height: 50px;
    position: absolute;
    top: 0px;
    margin-top: 0px !important;
    border-bottom: solid #cccccc 1px;
    overflow: hidden;
    display: flex;
    align-content: center;
    justify-content: center;
    font-size: 16px;
    font-weight: bolder;
    overflow: hidden;
    box-sizing: border-box;
    padding-top: 12px;
  }
  .editor_JD_avator {
      width: 78px;
      height: 78px;
      border-radius:  50% 50% 50% 50%;
      background: #ffffff;
      overflow: hidden;
      border: solid 0px #000000;
      box-sizing:border-box;
      font-size: 30px;
      margin-bottom: 30px;
      span {
          display: block;
      }
      .icon-tip {
        margin-top: 0px;
        width: 100%;
        height: 100%
      }
  }
  .pop-alert {

      flex-direction:column !important;
      * {
        margin-top:10px
      }
  }
  #code {
    width: 200px;
    border-radius: @radius;
    height: @inputH;
    margin-top: 0px;
  }
   #code-btn {
    border-radius: @radius;
    height: @inputH;
    overflow: hidden;
    margin-left:0px;
    margin-right:0px
  }

   .footer {
      display: flex;
      justify-content: center;
      align-items: center;
      height: @popFooterH;
      position: absolute !important;
      bottom: 0px !important;
      width: 100%;
    }
    input {
      border-radius: 6px;
    }
  .editor-pop-content1 {
    position: relative;
    width: 358px;
    height: 358px;
    background-color: #fff;
    border-radius: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    .tip {
      margin-top: 20px;
      p {
            text-align: left;
            font-size: 10px;
            color: rgba(0,0,0,0.65);
            margin-bottom: 5px;
            transform-origin: 0 0;
            transform: scale(0.9);
          }
    }
    .panel-wrap {
      position: relative;
      top: 100px;
    }
     .guide-item1 {
        display: flex;
        justify-content: center;
        margin-top: 35px;
        align-items: center;
        .tip {
          margin-top: 20px;
          .em {
            color: var(--ui-main-color);
          }
        }
      }
  }
}
</style>
